import { STATIC_URL } from 'constants/data'

const imgData = {
  certificate: {
    src: `${STATIC_URL}/courses/certificate.png`,
    alt: 'сертификат',
    width: 146,
    height: 200,
  },
  certificateDesc: {
    src: `${STATIC_URL}/courses/certificate_desktop.png`,
    alt: 'сертификат',
    width: 143,
    height: 203,
    unoptimized: true,
  },
  certificateFullMob: {
    src: `${STATIC_URL}/courses/certificate_full_mob.png`,
    alt: 'сертификат',
    width: 300,
    height: 426,
    unoptimized: true,
  },
  certificateFullDesk: {
    src: `${STATIC_URL}/courses/certificate_full_desktop.png`,
    alt: 'сертификат',
    width: 450,
    height: 638,
    unoptimized: true,
  },
}

export { imgData }
